import qs from 'qs';
import { AxiosInstance } from 'axios';
import { CollectionResource } from '@app/data/resources';
import {
    AddUserSpaceParticipantInput,
    ClaimUserSpaceInviteInput,
    CreateUserSpaceInviteInput,
    UpdateUserParticipationInput,
    UserSpaceFilterInput,
} from './inputs';
import { UserSpaceInviteResource, UserSpaceParticipationResource, UserSpaceResource } from './resources';
import { UserSpaceRef } from './refs';

export default class UserSpace {
    private basePath = '/api/user-space';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Create new user space invite
    createInvite = async (input: CreateUserSpaceInviteInput): Promise<UserSpaceRef> => {
        const { data } = await this.http.post(`${this.basePath}/invite`, input);
        return data;
    };

    // Claim use space invite
    claimInvite = async (id: ID, input: ClaimUserSpaceInviteInput): Promise<UserSpaceRef> => {
        const { data } = await this.http.post(`${this.basePath}/invite/${id}/claim`, input);
        return data;
    };

    // Get single invite info
    getInviteInfo = async (inviteId: ID, code: string): Promise<UserSpaceInviteResource> => {
        const query = qs.stringify({ code });

        const { data } = await this.http.get(`${this.basePath}/invite/${inviteId}/info?${query}`);
        return data;
    };

    // Fetch list of user spaces by participant ID
    get = async (filter: UserSpaceFilterInput): Promise<CollectionResource<UserSpaceResource, {}>> => {
        const query = qs.stringify({ ...filter });
        const { data } = await this.http.get(`${this.basePath}/?${query}`);
        return data;
    };

    // Get single user space info
    getById = async (id: ID): Promise<UserSpaceResource> => {
        const { data } = await this.http.get(`${this.basePath}/${id}`);
        return data;
    };

    // Get participation list for specific user space
    getParticipationForUserSpace = async (id: ID): Promise<CollectionResource<UserSpaceParticipationResource, {}>> => {
        const { data } = await this.http.get(`${this.basePath}/${id}/participation`);
        return data;
    };

    // Add new participant to user space
    addParticipant = async (id: ID, input: AddUserSpaceParticipantInput): Promise<UserSpaceRef> => {
        const { data } = await this.http.post(`${this.basePath}/${id}/participation`, input);
        return data;
    };

    // Update user participation inside user space
    updateParticipation = async (id: ID, userId: ID, input: UpdateUserParticipationInput): Promise<UserSpaceRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}/participation/${userId}`, input);
        return data;
    };

    // Remove participating user from space
    removeParticipation = async (id: ID, userId: ID): Promise<UserSpaceRef> => {
        const { data } = await this.http.delete(`${this.basePath}/${id}/participation/${userId}`);
        return data;
    };
}
